
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'

interface RawUploadTaskImagesVars {
  formData: FormData
  metadata: {
    PK: string
    SK: string
  }
}

interface RawUploadTaskImagesResponse {
  urls: string[]
}

const rawUploadFiles = async ({
  formData,
  metadata,
}: RawUploadTaskImagesVars): Promise<RawUploadTaskImagesResponse> => {
  const url = `${baseUrl}/aws/s3/raw-upload?PK=${metadata.PK}&SK=${metadata.SK}`
  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

const useRawUpload = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  return useMutation<RawUploadTaskImagesResponse, unknown, RawUploadTaskImagesVars>({
    mutationFn: rawUploadFiles,
    onError: (err, variables, context) => {
      console.error('Upload Error:', err)
      showSnackbar((err as any).response?.data?.message || (err as any).message, 'error')
    },
    onSuccess: data => {
      console.log('Images uploaded successfully:', data)
      showSnackbar('Images uploaded successfully', 'success')
    },
  })
}

export default useRawUpload
